import React, { useContext, useEffect, useState } from 'react';
import MainLayout from '../Container/Layout/MainLayout';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Context } from '../Context/Context';
import { toast } from 'react-toastify';
import styles from "../Styles/PaymentStatus.module.css"
import { getPaymentStatus } from '../Services/ContectService';


const PaymentStatus = () => {
    const [isPaid, setIsPaid] = useState(false);
    const [refId, setRefId] = useState("");
    const [orderCode, setOrderCode] = useState("");
    const { json, user, loading, setLoading } = useContext(Context);
    const navigate = useNavigate();

    // get query string
    const [searchParams, setSearchParams] = useSearchParams();

    const handleGetPaymentStatus = async () => {
        setLoading(true);
        try {
            const response = await getPaymentStatus(user, searchParams.get("Authority"));
            if (response.status === 200) {
                setIsPaid(response.data.status);
                setRefId(response.data.RefID);
                setOrderCode(response.data.order);
            }
        } catch (error) {
            toast.error(json.toast.err_1);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchParams.get("Authority")) {
            handleGetPaymentStatus();
        }
        else {
            return navigate(-1);
        }
    }, [searchParams]);

    return (
        <MainLayout>
            <div className="w-100 px-4 py-4 d-flex justify-content-center">
                <div className={styles.container}>
                    {loading ? (
                        "لطفاً صبر کنید..."
                    ) : (
                        <>
                            <div>
                                {isPaid ? (
                                    <svg width="200px" height="200px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#00AA00" d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z" /></svg>
                                ) : (
                                    <svg width="200px" height="200px" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g id="add" fill="#CC0000" transform="translate(42.666667, 42.666667)">
                                                <path d="M213.333333,3.55271368e-14 C331.136,3.55271368e-14 426.666667,95.5306667 426.666667,213.333333 C426.666667,331.136 331.136,426.666667 213.333333,426.666667 C95.5306667,426.666667 3.55271368e-14,331.136 3.55271368e-14,213.333333 C3.55271368e-14,95.5306667 95.5306667,3.55271368e-14 213.333333,3.55271368e-14 Z M262.250667,134.250667 L213.333333,183.168 L164.416,134.250667 L134.250667,164.416 L183.168,213.333333 L134.250667,262.250667 L164.416,292.416 L213.333333,243.498667 L262.250667,292.416 L292.416,262.250667 L243.498667,213.333333 L292.416,164.416 L262.250667,134.250667 Z" id="Combined-Shape">
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                )}
                            </div>
                            <div
                                className="mt-3 d-flex flex-column align-items-center"
                            >
                                {isPaid ?
                                    <>
                                        <span className="h3">
                                            پرداخت موفقیت آمیز بود.
                                        </span>
                                        <span className="h4 mt-1">
                                            کد رهگیری:&nbsp; {refId}
                                        </span>
                                        <span className="mt-4">
                                            <Link
                                                to={`/PrintFactor/${orderCode}`}
                                                className="main-btn main-btn-fill"
                                            >
                                                مشاهده فاکتور
                                            </Link>
                                        </span>
                                    </>
                                    :
                                    <>
                                        <span className="h3">
                                            پرداخت با خطا مواجه شد!
                                        </span>
                                        <span className="h4 mt-1">
                                            لطفاً مجدداً برای پرداخت تلاش نمایید.
                                        </span>
                                        <span className="mt-4">
                                            <Link to="/Order" className="main-btn main-btn-fill">
                                                پرداخت مجدد
                                            </Link>
                                        </span>
                                    </>

                                }
                            </div>
                        </>
                    )}
                </div>
            </div>
        </MainLayout>
    );
}

export default PaymentStatus;
